// extracted by mini-css-extract-plugin
export default {"recommender":"uL-z","recommenderCard":"vL-z","recommendationsNotMobileBadge":"wL-z","rowHasBadge":"xL-z"};